import React from 'react';

function Header({ onMenuClick }) {
  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : { name: 'Administrateur', email: 'admin@bkb.fr', role: { role_type: 'admin' } };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-4 md:px-8 py-4 flex justify-between items-center">
      <div className="flex items-center gap-2 md:gap-4">
        {/* Bouton Menu Hamburger - Visible seulement sur mobile */}
        <button
          onClick={onMenuClick}
          className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          aria-label="Toggle menu"
        >
          <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <img src="/logo-bkb.jpg" alt="Bank Kreiz Breizh" className="w-12 h-12 md:w-32 md:h-32 rounded-lg object-cover shadow-md" />
        <div className="hidden md:block">
          <h1 className="text-2xl font-bold text-gray-900">Bank Kreiz Breizh</h1>
          <p className="text-sm text-gray-600">Banque Centrale de Bretagne</p>
        </div>
        <div className="md:hidden">
          <h1 className="text-lg font-bold text-gray-900">BKB</h1>
        </div>
      </div>
      <div className="flex items-center gap-2 md:gap-4">
        <div className="text-right hidden sm:block">
          <p className="font-semibold text-gray-900 text-sm md:text-base">{user.name}</p>
          <p className="text-xs text-gray-500">{user.role?.role_type || 'client'}</p>
        </div>
        <div className="w-8 h-8 md:w-10 md:h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm md:text-base">
          {user.name?.charAt(0) || 'A'}
        </div>
      </div>
    </header>
  );
}

export default Header;
